var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sd-video",style:({
    width: _vm.width,
    height: _vm.height,
    opacity: (_vm.isActive) ? 1 : 0.6,
  })},[_c(_vm.source,{ref:_vm.source,tag:"component",staticClass:"sd-video__iframe",attrs:{"id":_vm.id,"channel":_vm.channel,"width":_vm.width,"height":_vm.height,"streamType":_vm.source,"quality":_vm.quality}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }